import React, { useEffect, useLayoutEffect, useState } from "react";
import { estEspaceOrganisateur } from "../../espace";
import { useHistory } from "react-router-dom";

const Navdata = () => {
	const history = useHistory();
	//state data
	const [isDashboard, setIsDashboard] = useState(false);
	const [isChauffeurs, setIsChauffeurs] = useState(false);
	const [isLivreurs, setIsLivreurs] = useState(false);
	const [isCourses, setIsCourses] = useState(false);
	const [isLivraisons, setIsLivraisons] = useState(false);
	const [isBilleteries, setIsBilleteries] = useState(false);
	const [isFinances, setIsFinances] = useState(false);
	const [isParrainages, setIsParrainages] = useState(false);
	const [isCodePromos, setIsCodePromos] = useState(false);
	const [isFacturation, setIsFacturation] = useState(false);
	const [isUsers, setIsUsers] = useState(false);
	const [isPlan, setIsPlan] = useState(false);
	const [isMessage, setIsMessage] = useState(false);
	const [isRemboursements, setIsRemboursements] = useState(false);

	const [isZones, setIsZones] = useState(false);
	const [isPaiements, setIsPaiements] = useState(false);
	const [isOrganisateurs, setIsOrganisateurs] = useState(false);
	const [isEvaluations, setIsEvaluations] = useState(false);
	const [isAuth, setIsAuth] = useState(false);
	const [isPages, setIsPages] = useState(false);
	const [isBaseUi, setIsBaseUi] = useState(false);
	const [isAdvanceUi, setIsAdvanceUi] = useState(false);
	const [isForms, setIsForms] = useState(false);
	const [isTables, setIsTables] = useState(false);
	const [isCharts, setIsCharts] = useState(false);
	const [isIcons, setIsIcons] = useState(false);
	const [isMaps, setIsMaps] = useState(false);
	const [isMultiLevel, setIsMultiLevel] = useState(false);

	// Authentication
	const [isSignIn, setIsSignIn] = useState(false);
	const [isSignUp, setIsSignUp] = useState(false);
	const [isPasswordReset, setIsPasswordReset] = useState(false);
	const [isPasswordCreate, setIsPasswordCreate] = useState(false);
	const [isLockScreen, setIsLockScreen] = useState(false);
	const [isLogout, setIsLogout] = useState(false);
	const [isSuccessMessage, setIsSuccessMessage] = useState(false);
	const [isVerification, setIsVerification] = useState(false);
	const [isError, setIsError] = useState(false);

	// Pages
	const [isProfile, setIsProfile] = useState(false);
	const [isLanding, setIsLanding] = useState(false);

	// Charts
	const [isApex, setIsApex] = useState(false);

	// Multi Level
	const [isLevel1, setIsLevel1] = useState(false);
	const [isLevel2, setIsLevel2] = useState(false);

	const [iscurrentState, setIscurrentState] = useState("Dashboard");

	function updateIconSidebar(e) {
		if (e && e.target && e.target.getAttribute("subitems")) {
			const ul = document.getElementById("two-column-menu");
			const iconItems = ul.querySelectorAll(".nav-icon.active");
			let activeIconItems = [...iconItems];
			activeIconItems.forEach((item) => {
				item.classList.remove("active");
				var id = item.getAttribute("subitems");
				if (document.getElementById(id))
					document.getElementById(id).classList.remove("show");
			});
		}
	}

	useEffect(() => {
		document.body.classList.remove("twocolumn-panel");
		if (iscurrentState !== "Dashboard") {
			setIsDashboard(false);
		}
		if (iscurrentState !== "Chauffeurs") {
			setIsChauffeurs(false);
		}
		if (iscurrentState !== "Livreurs") {
			setIsLivreurs(false);
		}
		if (iscurrentState !== "Courses") {
			setIsCourses(false);
		}
		if (iscurrentState !== "Livraisons") {
			setIsLivraisons(false);
		}
		if (iscurrentState !== "Billeteries") {
			setIsBilleteries(false);
		}
		if (iscurrentState !== "Finances") {
			setIsFinances(false);
		}
		if (iscurrentState !== "Parrainages") {
			setIsParrainages(false);
		}
		if (iscurrentState !== "CodePromos") {
			setIsCodePromos(false);
		}
		if (iscurrentState !== "Facturation") {
			setIsFacturation(false);
		}
		if (iscurrentState !== "Users") {
			setIsUsers(false);
		}
		if (iscurrentState !== "Message") {
			setIsMessage(false);
		}
		if (iscurrentState !== "Plan") {
			setIsPlan(false);
		}

		if (iscurrentState !== "Remboursements") {
			setIsRemboursements(false);
		}

		if (iscurrentState !== "Zones") {
			setIsZones(false);
		}
		if (iscurrentState !== "Paiements") {
			setIsPaiements(false);
		}
		if (iscurrentState !== "Evaluations") {
			setIsEvaluations(false);
		}
		if (iscurrentState !== "Auth") {
			setIsAuth(false);
		}
		if (iscurrentState !== "Pages") {
			setIsPages(false);
		}
		if (iscurrentState !== "BaseUi") {
			setIsBaseUi(false);
		}
		if (iscurrentState !== "AdvanceUi") {
			setIsAdvanceUi(false);
		}
		if (iscurrentState !== "Forms") {
			setIsForms(false);
		}
		if (iscurrentState !== "Tables") {
			setIsTables(false);
		}
		if (iscurrentState !== "Charts") {
			setIsCharts(false);
		}
		if (iscurrentState !== "Icons") {
			setIsIcons(false);
		}
		if (iscurrentState !== "Maps") {
			setIsMaps(false);
		}
		if (iscurrentState !== "MuliLevel") {
			setIsMultiLevel(false);
		}
		if (iscurrentState === "Widgets") {
			history.push("/widgets");
			document.body.classList.add("twocolumn-panel");
		}
		if (iscurrentState !== "Landing") {
			setIsLanding(false);
		}
	}, [
		history,
		iscurrentState,
		isDashboard,
		isChauffeurs,
		isLivreurs,
		isCourses,
		isPlan,
		isLivraisons,
		isBilleteries,
		isFinances,
		isParrainages,
		isCodePromos,
		isUsers,
		isMessage,
		isRemboursements,

		isZones,
		isPaiements,
		isEvaluations,
		isAuth,
		isPages,
		isBaseUi,
		isAdvanceUi,
		isForms,
		isTables,
		isCharts,
		isIcons,
		isMaps,
		isMultiLevel,
	]);

	// Lu dès le premier rendu, pas dans un useEffect : la valeur arrivait
	// après, si bien que le menu complet de l'administration — chauffeurs,
	// courses, finances — s'affichait d'abord, puis était remplacé. Un
	// organisateur le voyait passer à chaque chargement de page.
	const lireRole = () => {
		try {
			const brut = localStorage.getItem("authUser");
			return brut ? JSON.parse(brut).role || "" : "";
		} catch (e) {
			return "";
		}
	};

	const [roleSession, setRoleSession] = useState(lireRole);

	useEffect(() => {
		setRoleSession(lireRole());
	}, []);

	// L'espace prime sur le rôle : sur organisateur.takci.pro, le menu de
	// l'administration n'a aucune raison d'exister, quoi que porte la session.
	const menuOrganisateur =
		estEspaceOrganisateur || roleSession === "ORGANISATEUR";

	let menuItems;

	{
		menuOrganisateur
			? (menuItems = [
					// !
					{
						id: "Dashboard",
						label: `Dashboards`,
						icon: "ri-dashboard-2-line",
						link: "/#",
						stateVariables: isDashboard,
						click: function (e) {
							e.preventDefault();
							setIsDashboard(!isDashboard);
							setIscurrentState("Dashboard");
							updateIconSidebar(e);
						},
					},
					{
						id: "CodePromoOrga",
						label: "Code de réduction",
						icon: "ri-price-tag-3-line",
						link: "/code-promo",
						click: function (e) {
							e.preventDefault();
							setIscurrentState("CodePromoOrga");
						},
					},
					{
						id: "Billeteries",
						label: "Events",
						icon: "ri-ticket-2-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsBilleteries(!isBilleteries);
							setIscurrentState("Billeteries");
							updateIconSidebar(e);
						},
						stateVariables: isBilleteries,
						subItems: [
							{
								id: "Liste des evenements",
								label: "List of events",
								link: "/evenements",
								parentId: "Billeteries",
							},
						],
					},
					{
						id: "Paiements",
						label: "Paiements",
						icon: "ri-money-dollar-circle-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsPaiements(!isPaiements);
							setIscurrentState("Paiements");
							updateIconSidebar(e);
						},
						stateVariables: isPaiements,
						subItems: [
							{
								id: "Paies des organisateurs",
								label: "Historique des paiements",
								link: "/organisateurs-paid",
								parentId: "Billeteries",
							},
							{
								id: "Demandes Paies des organisateurs",
								label: "Demandes des paiements",
								link: "/organisateurs-ask-pay",
								parentId: "Billeteries",
							},
						],
					},
					// {
					// 	id: "Finances",
					// 	label: "Finances",
					// 	icon: "ri-funds-line",
					// 	link: "/#",
					// 	click: function (e) {
					// 		e.preventDefault();
					// 		setIsFinances(!isFinances);
					// 		setIscurrentState("Finances");
					// 		updateIconSidebar(e);
					// 	},
					// 	stateVariables: isFinances,
					// 	subItems: [
					// 		{
					// 			id: "Revenus par activité",
					// 			label: "Earnings by activity",
					// 			link: "/finances",
					// 			parentId: "Finances",
					// 		},
					// 	],
					// },
					{
						id: "Users",
						label: "Accounts",
						icon: "ri-user-3-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsUsers(!isUsers);
							setIscurrentState("Users");
							updateIconSidebar(e);
						},
						stateVariables: isUsers,
						subItems: [
							{
								// « Sécurités » désignait en fait les agents qui
								// scannent les billets à l'entrée. L'identifiant
								// « Client » était repris d'une autre entrée et
								// entrait en conflit avec elle.
								id: "AgentsControleurs",
								label: "Agents contrôleurs",
								link: "/security",
								parentId: "Users",
							},
						],
					},
					{
						id: "Alertes",
						label: "Alertes",
						icon: "bx bx-bell",
						link: "/alertes",
						stateVariables: isMessage,
						click: function (e) {
							e.preventDefault();
							setIsMessage(!isMessage);
							setIscurrentState("Message");
							updateIconSidebar(e);
						},
					},
				]):(menuItems = [
					{
						id: "Dashboard",
						label: `Tableau de bord`,
						icon: "ri-dashboard-2-line",
						link: "/#",
						stateVariables: isDashboard,
						click: function (e) {
							e.preventDefault();
							setIsDashboard(!isDashboard);
							setIscurrentState("Dashboard");
							updateIconSidebar(e);
						},
					},
					{
						id: "Plan",
						label: "Plan",
						icon: "ri-road-map-line",
						link: "/plan",
						stateVariables: isPlan,
						click: function (e) {
							e.preventDefault();
							setIsPlan(!isPlan);
							setIscurrentState("Plan");
							updateIconSidebar(e);
						},
					},
					{
						id: "Facturation",
						label: "Types d'engin",
						icon: "bx bx-list-ul",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsFacturation(!isFacturation);
							setIscurrentState("Facturation");
							updateIconSidebar(e);
						},
						stateVariables: isFacturation,
						subItems: [
							{
								id: "Type engin",
								label: "Type d'engin",
								link: "/type-engin",
								parentId: "Facturation",
							},
							{
								id: "Facturation des courses",
								label: "Facturation des courses",
								link: "/facturation",
								parentId: "Facturation",
							},
							{
								id: "Majoration des courses",
								label: "Majoration des courses",
								link: "/majoration-courses",
								parentId: "Facturation",
							},
						],
					},
					{
						id: "Chauffeurs",
						label: "Chauffeurs",
						icon: "ri-user-settings-line",
						link: "/#",
						stateVariables: isChauffeurs,
						click: function (e) {
							e.preventDefault();
							setIsChauffeurs(!isChauffeurs);
							setIscurrentState("Chauffeurs");
							updateIconSidebar(e);
						},
						subItems: [
							{
								id: "Liste des chauffeurs",
								label: "Liste des chauffeurs",	
								link: "/chauffeur",
								parentId: "Chauffeurs",
							},
							{
								id: "Chauffeurs en attente",
								label: "Comptes en attente",
								link: "/chauffeur-en-attente",
								parentId: "Chauffeurs",
							},
						],
					},
					{
						id: "Livreurs",
						label: "Livreurs",
						icon: "ri-user-settings-line",
						link: "/#",
						stateVariables: isLivreurs,
						click: function (e) {
							e.preventDefault();
							setIsLivreurs(!isLivreurs);
							setIscurrentState("Livreurs");
							updateIconSidebar(e);
						},
						subItems: [
							{
								id: "Liste des livreurs",
								label: "Liste des livreurs",
								link: "/livreur",
								parentId: "Livreurs",
							},
							{
								id: "Livreurs en attente",
								label: "Comptes en attente",
								link: "/livreur-en-attente",
								parentId: "Livreurs",
							},
						],
					},
					{
						id: "Courses",
						label: "Courses",
						icon: "ri-roadster-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsCourses(!isCourses);
							setIscurrentState("Courses");
							updateIconSidebar(e);
						},
						stateVariables: isCourses,
						subItems: [
							{
								id: "Historique des courses",
								label: "Historique des courses",
								link: "/courses",
								parentId: "Courses",
							},
							{
								id: "Courses en attente",
								label: "Courses en attente",
								link: "/courses-attente",
								parentId: "Courses",
							},
							{
								id: "Courses annulees",
								label: "Courses annulées",
								link: "/courses-annulee",
								parentId: "Courses",
							},
						],
					},
					{
						id: "Livraisons",
						label: "Livraisons",
						icon: "ri-shopping-cart-2-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsLivraisons(!isLivraisons);
							setIscurrentState("Livraisons");
							updateIconSidebar(e);
						},
						stateVariables: isLivraisons,
						subItems: [
							{
								id: "Historique des livraisons",
								label: "Historique des livraisons",
								link: "/livraisons",
								parentId: "Livraisons",
							},
							{
								id: "Livraisons en attente",
								label: "Livraisons en attente",
								link: "/livraisons-attente",
								parentId: "Livraisons",
							},
							{
								id: "Livraisons annulees",
								label: "Livraisons annulées",
								link: "/livraisons-annulee",
								parentId: "Livraisons",
							},
						],
					},
					{
						id: "Billeteries",
						label: "Événements",
						icon: "ri-ticket-2-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsBilleteries(!isBilleteries);
							setIscurrentState("Billeteries");
							updateIconSidebar(e);
						},
						stateVariables: isBilleteries,
						subItems: [
							{
								id: "Liste des evenements",
								label: "Liste des événements",
								link: "/evenements",
								parentId: "Billeteries",
							},
						],
					},
					// Les organisateurs sont des comptes, au même titre que les
					// chauffeurs ou les clients : ils étaient rangés sous
					// « Events » et leurs paiements ailleurs encore, dans un
					// menu « Paiements » qui ne contenait rien d'autre.
					{
						id: "OrganisateursAdmin",
						label: "Organisateurs",
						icon: "ri-user-star-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsOrganisateurs(!isOrganisateurs);
							setIscurrentState("OrganisateursAdmin");
							updateIconSidebar(e);
						},
						stateVariables: isOrganisateurs,
						subItems: [
							{
								id: "Liste des organisateurs",
								label: "Liste des organisateurs",
								link: "/organisateurs",
								parentId: "OrganisateursAdmin",
							},
							{
								id: "Historique des paiements organisateurs",
								label: "Historique des paiements",
								link: "/organisateurs-paid",
								parentId: "OrganisateursAdmin",
							},
							{
								id: "Demandes de paiement organisateurs",
								label: "Demandes de paiement",
								link: "/organisateurs-ask-pay",
								parentId: "OrganisateursAdmin",
							},
						],
					},
					{
						id: "Remboursements",
						label: "Remboursements",
						icon: "ri-ticket-2-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsRemboursements(!isRemboursements);
							setIscurrentState("Remboursements");
							updateIconSidebar(e);
						},
						stateVariables: isRemboursements,
						subItems: [
							{
								id: "Templates des Plans de remboursements des chauffeurs",
								label: "Templates des Plans",
								link: "/plans",
								parentId: "Paiements",
							},
							{
								id: "Tout les plans de remboursements des chauffeurs",
								label: "Liste des plans de remboursements",
								link: "/allremboursements",
								parentId: "Paiements",
							},
							{
								id: "Plan de remboursements des drivers",
								label: "Plan des remboursements",
								link: "/remboursements",
								parentId: "Paiements",
							},
							{
								id: "Parametres des plans de remboursements",
								label: "Parametre des plans de remboursements",
								link: "/parametres-remboursements",
								parentId: "Paiements",
							},
						],
					},
					// {
					// 	id: "Remboursements",
					// 	label: "Remboursements",
					// 	icon: "bx bx-bell",
					// 	link: "/remboursements",
					// 	stateVariables: isRemboursements,
					// 	click: function (e) {
					// 		e.preventDefault();
					// 		setIsRemboursements(!isRemboursements);
					// 		setIscurrentState("Remboursements");
					// 		updateIconSidebar(e);
					// 	},
					// },
					{
						id: "Finances",
						label: "Finances",
						icon: "ri-funds-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsFinances(!isFinances);
							setIscurrentState("Finances");
							updateIconSidebar(e);
						},
						stateVariables: isFinances,
						subItems: [
							{
								id: "Revenus par activité",
								label: "Revenus par activité",
								link: "/finances",
								parentId: "Finances",
							},
						],
					},
					{
						id: "Parrainages",
						label: "Parrainages",
						icon: "ri-coupon-2-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsParrainages(!isParrainages);
							setIscurrentState("Parrainages");
							updateIconSidebar(e);
						},
						stateVariables: isParrainages,
						subItems: [
							{
								id: "Code parrainage",
								label: "Historique des parrainages",
								link: "/parainage",
								parentId: "code parrainage",
							},
						],
					},
					{
						id: "CodePromos",
						label: "Codes promo",
						icon: "ri-coupon-3-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsCodePromos(!isCodePromos);
							setIscurrentState("CodePromos");
							updateIconSidebar(e);
						},
						stateVariables: isCodePromos,
						subItems: [
							{
								id: "Liste des codes promo",
								label: "Liste des codes promo",
								link: "/code-promo",
								parentId: "CodePromos",
							},
						],
					},
					{
						id: "Users",
						label: "Comptes",
						icon: "ri-user-3-line",
						link: "/#",
						click: function (e) {
							e.preventDefault();
							setIsUsers(!isUsers);
							setIscurrentState("Users");
							updateIconSidebar(e);
						},
						stateVariables: isUsers,
						subItems: [
							{
								id: "Client",
								label: "Clients",
								link: "/client",
								parentId: "Users",
							},
							{
								id: "Admin",
								label: "Admin",
								link: "/admin",
								parentId: "Users",
							},
							// {
							//   id: "Historique Admin",
							//   label: "Activités des Admins",
							//   link: "/historique-activity",
							//   parentId: "Users",
							// },
						],
					},
					{
						id: "Alertes",
						label: "Alertes",
						icon: "bx bx-bell",
						link: "/alertes",
						stateVariables: isMessage,
						click: function (e) {
							e.preventDefault();
							setIsMessage(!isMessage);
							setIscurrentState("Message");
							updateIconSidebar(e);
						},
					},
			]);
	}

	return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
